import { researchPlatform } from '@stereoagency/sanity-schema';

export const researchPlatformsQuery = researchPlatform.schema.builder
  .filter(
    'count($taxonomies) == 0 || count(taxonomies[_ref in $taxonomies]) > 0'
  )
  .pick(['slug', 'title', 'introduction'])
  .map((resolver) => ({
    taxonomies: resolver.taxonomies
      .resolveIn(['_id', 'type', 'slug', 'name'])
      .use(),
    researchPlatformLeader: resolver.researchPlatformLeader
      .resolve(['name', 'firstName', 'image'])
      .use()
  }))
  .use();
